import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { EnvService } from "src/app/env.service";
import { map, tap } from "rxjs/operators";

function getXauth() {
  let loginData = JSON.parse(localStorage.getItem("loginData")) || {};
  let xAuth = loginData.token;
  return xAuth;
}

let httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json", //,
    // 'x-auth': getXauth()
  }),
};

@Injectable({
  providedIn: "root",
})
export class GroupsService {
  url;
  private groupEventSource = new Subject<any>();
  private reloadListSource = new Subject<any>();
  groupEvent$ = this.groupEventSource.asObservable();
  reloadList$ = this.reloadListSource.asObservable();

  constructor(
    private http: HttpClient,
    private env: EnvService,
  ) {
    this.url = env.apiUrl + "groups/";
  }

  passGroupEvent(event) {
    this.groupEventSource.next(event);
  }

  reloadList() {
    this.reloadListSource.next(null);
  }

  getGroups(): Observable<any> {
    return this.http.get(this.url + "getGroups", httpOptions);
  }

  getGroup(id): Observable<any> {
    return this.http.get(this.url + "get/?id=" + id, httpOptions);
  }

  getUserGroups(): Observable<any> {
    return this.http.get(this.url + "get-my-groups/", httpOptions).pipe(
      map((groups: any) => {
        let userData = JSON.parse(localStorage.getItem("userData")) || {
          id: null,
          firstName: null,
          lastName: null,
        };
        groups.push({
          _id: userData.id,
          name: userData.firstName + " " + userData.lastName,
        });
        return groups;
      }),
      tap((groups) =>
        localStorage.setItem("userGroups", JSON.stringify(groups)),
      ),
    );
  }

  createGroup(data): Observable<any> {
    return this.http
      .post(this.url + "createGroup", data, httpOptions)
      .pipe(
        tap((res) => {
          this.getUserGroups().subscribe();
          this.passGroupEvent(res);
        })
      );
  }

  editGroupDescription(data): Observable<any> {
    return this.http
      .post(this.url + "editGroupDescription", data, httpOptions)
      .pipe(
        tap((res) => {
          this.getUserGroups().subscribe();
          this.passGroupEvent(res);
        })
      );
  }

  editGroupName(data): Observable<any> {
    return this.http
      .post(this.url + "editGroupName", data, httpOptions)
      .pipe(
        tap((res) => {
          this.getUserGroups().subscribe();
          this.passGroupEvent(res);
        })
      );
  }

  findEntity(query): Observable<any> {
    return this.http.get(this.url + "findEntity/?query=" + query, httpOptions);
  }
  commitAddRemoveChanges(data): Observable<any> {
    return this.http.post(
      this.url + "remove-add-multiple-entities/",
      data,
      httpOptions,
    );
  }
  editEntity(data): Observable<any> {
    return this.http.post(this.url + "editEntity/", data, httpOptions);
  }
  addEntity(data): Observable<any> {
    return this.http.post(this.url + "addEntity/", data, httpOptions);
  }
  transferEntity(data): Observable<any> {
    return this.http.post(this.url + "transferEntity/", data, httpOptions);
  }
  deleteGroup(id): Observable<any> {
    return this.http
      .get(this.url + "deleteGroup/?id=" + id, httpOptions)
      .pipe(
        tap((res) => {
          this.getUserGroups().subscribe();
          this.passGroupEvent({ type: "delete", id });
        })
      );
  }
  deleteMember(data): Observable<any> {
    return this.http.post(this.url + "deleteMember/", data, httpOptions);
  }
}
